export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7651.4999d246.jpg";